module.exports = "../../../../platform/assets/pageMainIcon/business_yewushezhilei4.svg";